export * from './update-token';
export const version = 1;
